import { Container, Stack, Text } from '@mantine/core';
import { FC, memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { links } from 'src/router/routes';

import { Button } from '../Button';
import styles from './styles.module.css';

type Props = {
  description?: string;
  buttonText?: string;
  onButtonClick?: () => void;
};

export const NotFound: FC<Props> = memo(
  ({ description, onButtonClick, buttonText }) => {
    const defaultDescription = "The page you're looking for doesn't exist";
    const navigate = useNavigate();

    const handleButtonClick = () => {
      if (onButtonClick) {
        onButtonClick();
      } else {
        navigate(links.dashboard);
      }
    };

    return (
      <Container h="100%" w="100%" display="flex" className={styles.wrapper}>
        <Stack align="center" gap="md">
          <Text fw={500} size="xl">
            Not Found
          </Text>
          <Text size="sm">{description || defaultDescription}</Text>
          <Button variant="outline" round size="sm" onClick={handleButtonClick}>
            {buttonText || 'Go to dashboard'}
          </Button>
        </Stack>
      </Container>
    );
  }
);
